module.exports = __webpack_public_path__ + "img/poster_Entitlement_R2.a81f4355.jpg";